<template>
  <div class="product" data-testid="product-tile">
    <div class="product__images">
      <WishlistButton
        class="wishlist-button"
        data-testid="wishlist-button-plp"
        :product="product"
        light
      />
      <a
        :href="product.onlineStoreUrl"
        class="product__image-link"
        data-testid="product-image-link"
      >
        <IntersectionObserver
          v-for="image in images"
          v-slot="{ intersected }"
          :key="image.id"
          class="picture-container"
        >
          <Picture
            :images="image"
            :intersected="intersected"
            height="308"
            width="205"
          />
        </IntersectionObserver>
      </a>
    </div>
    <InfoActions :product="product" />
  </div>
</template>

<script>
import InfoActions from "@/components/product-tile/InfoActions.vue";
import Picture from "@/components/Picture.vue";
import WishlistButton from "@/components/WishlistButton.vue";
import { unwrapNodes } from "@/helpers/graphql";
import IntersectionObserver from "@/components/IntersectionObserver.vue";

export default {
  name: "ProductTile",
  components: {
    Picture,
    WishlistButton,
    IntersectionObserver,
    InfoActions,
  },
  inject: ["mq"],
  props: {
    product: {
      type: Object,
      required: true,
    },
    showOnePhoto: {
      type: Boolean,
      default: false,
    },
    flatLays: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    images() {
      const flatLayImages =
        unwrapNodes(this.product.flatlays?.references?.edges) || [];

      if (this.flatLays && flatLayImages.length > 0) {
        return flatLayImages.map((flatLay) => {
          return {
            ...flatLay.image,
          };
        });
      }

      const images = unwrapNodes(this.product.images.edges);
      if ((this.showOnePhoto || this.mq.mdPlus) && images.length > 0) {
        return [images[0]];
      }
      return images;
    },
  },
};
</script>

<style lang="scss" scoped>
.product {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.product__images {
  display: flex;
  overflow-x: scroll;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  white-space: nowrap;
  line-height: 0;
  position: relative;

  &::-webkit-scrollbar {
    display: none;
  }

  & .picture-container {
    scroll-snap-align: center;
    display: inline-block;
    position: relative;
    width: 100%;
  }
}

.product__image-link {
  display: block;
  width: 100%;
}

.wishlist-button {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 3;
}
</style>
